import {Component, OnInit, OnDestroy, AfterViewInit} from '@angular/core';
import {DataService} from '../../../../Services/data.service';
import {Router} from '@angular/router';
import {StorageService} from '../../../../Services/storage.service';
import {AppConfigService} from '../../../../Services/app-config.service';
import {NotificationService} from '../../../../Services/notification.service';
import {ResponseModel} from '../../../../DataModels/response-model';
import {DateFilterService} from '../../../../Services/dateFilter.service';
import {NgbPaginationConfig} from '@ng-bootstrap/ng-bootstrap';
import {PagerStateService} from '../../../../Services/pager-state.service';
import {NgbpaginationConfigService} from '../../../../Services/ngbpagination-config.service';
import {Title} from '@angular/platform-browser';
import {ListPageBase} from '../../../list-page-base';

@Component({
  selector: 'app-account-subtotal-list',
  templateUrl: './account-subtotal-list.component.html',
  styleUrls: ['./account-subtotal-list.component.css'],
  standalone: false
})
export class AccountSubtotalListComponent extends ListPageBase implements OnInit, OnDestroy, AfterViewInit {
  subTotalCount = 0;
  checkedInfo: any;
  isLoaded = false;

  constructor(
    private table: DataService,
    private toastr: NotificationService,
    private storage: StorageService,
    private dateFilter: DateFilterService,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService,
    private titleService: Title
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }



  vm: any = [];

  ngOnInit() {
    this.restorePagerState();
    this.vm.list = [];
    this.vm.parentData = false;
    this.vm.childrenData = false;

    this.getData();
  }

  ngAfterViewInit(): void {
    this.titleService.setTitle($localize`:Account Subtotal List @@accountSubtotalList:Account Subtotal List`);
  }

  ngOnDestroy(): void {
    // no legacy dt resources to clean
  }

  getData(): void {
    let paramString = '?search=' + ((this.vm.searchTerm) ? this.vm.searchTerm : '');
    paramString += '&fromDate=' + ((this.vm.fromDate) ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString += '&toDate=' + ((this.vm.toDate) ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page - 1);
    paramString += '&pageSize=' + this.pageSize;

    this.table.getApiListData('account_subtotal' + paramString).subscribe((result: ResponseModel) => {
      this.vm.list = result.Data;

      this.totalRecords = result.totalRecords;
      this.paginate(false);

      this.isLoaded = true;
      this.subTotalCount = result.totalRecords;
    });
  }

  getParentSubAccountData(event): void {
    if (event) {
      let paramString = '?search=' + ((this.vm.searchTerm) ? this.vm.searchTerm : '');
      paramString += '&fromDate=' + ((this.vm.fromDate) ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
      paramString += '&toDate=' + ((this.vm.toDate) ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
      paramString += '&pageNumber=' + (this.page - 1);
      paramString += '&pageSize=' + this.pageSize;
      this.table.getApiListData('account_subtotal/parents' + paramString).subscribe((result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
        this.isLoaded = true;
      });
    } else {
      this.getPagedApiData();
    }
  }

  getChildSubAccountData(event): void {
    if (event) {
      let paramString = '?search=' + ((this.vm.searchTerm) ? this.vm.searchTerm : '');
      paramString += '&fromDate=' + ((this.vm.fromDate) ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
      paramString += '&toDate=' + ((this.vm.toDate) ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
      paramString += '&pageNumber=' + (this.page - 1);
      paramString += '&pageSize=' + this.pageSize;
      this.table.getApiListData('account_subtotal/children' + paramString).subscribe((result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
        this.isLoaded = true;
      });
    } else {
      this.getPagedApiData();
    }
  }

  onNavigate(aID: string) {
    if (this.vm.parentData || this.vm.childrenData) {
      localStorage.removeItem('pager_state_' + this.router.url);
    }
    this.router.navigate(['admin/account-subtotal-form', {id: aID}]).then();
  }

  // ----------------- Server side paging --------------------

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    let paramString = '?search=' + ((this.vm.searchTerm) ? this.vm.searchTerm : '');
    paramString += '&fromDate=' + ((this.vm.fromDate) ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString += '&toDate=' + ((this.vm.toDate) ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page - 1);
    paramString += '&pageSize=' + this.pageSize;

    this.table.getApiListData('account_subtotal' + paramString).subscribe((result: ResponseModel) => {
      this.vm.list = result.Data;
      this.totalRecords = result.totalRecords;
      this.paginate(false);
      this.isLoaded = true;
    });
  }

  serverSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    if (this.vm.parentData) {
      this.getParentSubAccountData(true);
    } else if (this.vm.childrenData) {
      this.getChildSubAccountData(true);
    } else {
      this.getPagedApiData();
    }
  }

  clearServerSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    if (this.vm.parentData) {
      this.getParentSubAccountData(true);
    } else if (this.vm.childrenData) {
      this.getChildSubAccountData(true);
    } else {
      this.getPagedApiData();
    }
  }

// ----------------- End server side paging --------------------


  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }
}
